module.exports = __webpack_public_path__ + "static/img/sparta.67647233.png";